import AsyncStorage from "@react-native-async-storage/async-storage";
import axios from "axios";
import {endpoints} from "@api/apis";

export const mfCentralEvaluateFundsPollar = async (payload: {
    applicationId: string;
}) => {
    let applicationIdStored = await AsyncStorage.getItem('application_id')
    const applicationId = applicationIdStored ?? payload?.applicationId
    return await axios.get(`${endpoints.mfCentralEvaluateFunds}${applicationId}`);

}
export const pledgeLimitAPICall = async (payload: {
    applicationId: string;
}) => {
    let applicationIdStored = await AsyncStorage.getItem('application_id')
    const applicationId = applicationIdStored ?? payload?.applicationId
    return await axios.get(`${endpoints.pledgeLimit}${applicationId}`);

}